// export const API_URL = 'http://172.22.0.91:310//api/'; // developing 
// export const API_URL = 'http://172.22.0.91:330//api/'; //testing Arish
// export const API_URL = 'http://172.22.0.91:300//api/'; // testing server 
//export const API_URL = 'http://104.218.120.125:150//api/'; // Live Server 
//export const API_URL = 'http://104.218.120.125:180//api/'; // Live Server testing 

//export const API_URL = 'http://41.33.39.171:150///api/'; //live server 
//expo  rt const API_URL = 'http://localhost:27739///api/';  //local host for testing
//export const API_URL = 'http://41.33.39.171:180///api/'; //Live Testing server 
// export const API_URL ='http://41.33.39.169:150///api/'; //Live production student server 
export const API_URL = 'http://Unicodesis.su.edu.eg:150///api/'; // livehttp
// export const API_URL = 'http://104.218.120.125:260///api/'; // livehttp amr
// export const API_URL = 'https://suapplication.su.edu.eg:449///api/'; // livehttp amr2
//export const API_URL = process.env.VUE_APP_API_URL; //Live Testing server 
// export const API_URL = 'http://104.218.120.109:400//api/'; // Elareesh 
// export const API_URL = 'https://unicodeasis.su.edu.eg:321//api/'; // New-Elareesh 
// export const API_URL = 'https://suapplication.su.edu.eg:449//api/'; // spear 


